import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import Logo from "../assets/copysa.svg"; // Adjust the path to your logo
import CircularProgress from "@mui/material/CircularProgress";
import { CheckLogin } from "../services/user/user";
import { useTranslation } from "react-i18next";
const SplashScreen = ({ onComplete }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with your API endpoint
        const response = await CheckLogin();

        if (response.ok) {
          const data = await response.json();
          // Handle the data as needed
          onComplete(data);
        } else {
        }
      } catch (error) {}
    };

    fetchData();

    onComplete(); // Call to transition to main app after random delay
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(180deg, rgba(65,41,90,1) 0%, rgba(47,7,67,1) 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: "white",
      }}
    >
      <img src={Logo} width={225} height={100} alt="Logo" />
      <Typography variant="h3" sx={{ marginTop: "2rem", marginBottom: "2rem" }}>
        {t("Splash.title")}
      </Typography>
      <CircularProgress color="#ffff" />
    </Box>
  );
};

export default SplashScreen;
